import type { FastifyInstance } from 'fastify'
import type { ClanController } from './clan.controller.js'
import { authMiddleware } from '../../middleware/auth.middleware.js'

export async function clanRoutes(
  app: FastifyInstance,
  controller: ClanController
) {
  // Apply auth to all routes
  app.addHook('onRequest', authMiddleware)

  // ========================================
  // CLAN MANAGEMENT
  // ========================================

  app.post('/', {
    handler: controller.createClan.bind(controller)
  })

  app.get('/my', {
    handler: controller.getUserClans.bind(controller)
  })

  app.get('/search', {
    handler: controller.searchClans.bind(controller)
  })

  app.get('/:clanId', {
    handler: controller.getClan.bind(controller)
  })

  app.patch('/:clanId', {
    handler: controller.updateClan.bind(controller)
  })

  app.delete('/:clanId', {
    handler: controller.deleteClan.bind(controller)
  })

  // ========================================
  // MEMBER MANAGEMENT
  // ========================================

  app.post('/:clanId/join', {
    handler: controller.joinClan.bind(controller)
  })

  app.post('/:clanId/leave', {
    handler: controller.leaveClan.bind(controller)
  })

  app.delete('/:clanId/members/:userId', {
    handler: controller.kickMember.bind(controller)
  })

  app.patch('/:clanId/members/:userId/role', {
    handler: controller.updateMemberRole.bind(controller)
  })

  // ========================================
  // CHAT MESSAGES
  // ========================================

  app.post('/:clanId/messages', {
    handler: controller.sendMessage.bind(controller)
  })

  app.get('/:clanId/messages', {
    handler: controller.getMessages.bind(controller)
  })

  app.delete('/:clanId/messages/:messageId', {
    handler: controller.deleteMessage.bind(controller)
  })

  // ========================================
  // FEED POSTS
  // ========================================

  app.post('/:clanId/posts', {
    handler: controller.createPost.bind(controller)
  })

  app.get('/:clanId/posts', {
    handler: controller.getPosts.bind(controller)
  })

  app.post('/:clanId/posts/:postId/like', {
    handler: controller.likePost.bind(controller)
  })

  app.delete('/:clanId/posts/:postId', {
    handler: controller.deletePost.bind(controller)
  })

  // ========================================
  // COMMENTS
  // ========================================

  app.post('/:clanId/posts/:postId/comments', {
    handler: controller.createComment.bind(controller)
  })

  app.get('/:clanId/posts/:postId/comments', {
    handler: controller.getComments.bind(controller)
  })

  app.delete('/:clanId/posts/:postId/comments/:commentId', {
    handler: controller.deleteComment.bind(controller)
  })

  // ========================================
  // INVITES
  // ========================================

  app.post('/:clanId/invites', {
    handler: controller.inviteUser.bind(controller)
  })

  app.get('/invites/my', {
    handler: controller.getUserInvites.bind(controller)
  })

  app.post('/invites/:inviteId/accept', {
    handler: controller.acceptInvite.bind(controller)
  })

  app.post('/invites/:inviteId/decline', {
    handler: controller.declineInvite.bind(controller)
  })

  // ========================================
  // PRESENCE
  // ========================================

  app.post('/:clanId/presence', {
    handler: controller.updatePresence.bind(controller)
  })

  app.get('/:clanId/presence', {
    handler: controller.getOnlineMembers.bind(controller)
  })
}
